import styled from 'styled-components';
import { mixins, colors } from '../../css';
import { CenteredContainer } from '../../css/styledComponents.styles';

const tabHeaderHeight = '48px';

export const StyledCenteredContainer = styled(CenteredContainer)`
  padding: ${mixins.pxToRem(5)};
`;

export const TabContainer = styled.div`
  background-color: white;
  min-height: calc(100vh - ${mixins.pxToRem(225)});
  margin-bottom: ${mixins.pxToRem(20)};
  height: calc(100% - ${tabHeaderHeight});
  ${(props) =>
    Object.keys(props.themeCustom).length > 0 &&
    Object.prototype.hasOwnProperty.call(props.themeCustom, 'TabContainer') &&
    props.themeCustom.TabContainer};
  &.subBar {
    min-height: calc(100vh - ${mixins.pxToRem(265)});
    ${(props) =>
      Object.keys(props.themeCustom).length > 0 &&
      Object.prototype.hasOwnProperty.call(props.themeCustom, 'TabContainer_SubBar') &&
      props.themeCustom.TabContainer_SubBar};
  }
`;

export const SubBar = styled.div`
  ${({ theme }) => `background-color: ${theme.mainTheme}`};
  ${(props) => props.themeNeutral && `background-color: #f5f5f5`};
  height: ${mixins.pxToRem(40)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${mixins.pxToRem(20)};
  width: 100%;
  margin-top: -0.5px;
  ${(props) =>
    Object.keys(props.themeCustom).length > 0 &&
    Object.prototype.hasOwnProperty.call(props.themeCustom, 'SubBar') &&
    props.themeCustom.SubBar};
`;

export const LeftSubBarContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: auto;
  max-width: 100%;
  button {
    margin-right: ${mixins.pxToRem(10)};
  }
`;

export const RightSubBarContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-left: auto;
  max-width: 100%;
  button {
    margin-left: ${mixins.pxToRem(10)};
  }
`;

export const ChipBar = styled.div`
  width: 100%;
  padding: ${mixins.pxToRem(5)};
  background-color: ${colors.colorGrey04};
`;

export const TabBarContainer = styled.div`
  width: 100%;
  position: relative;
  height: 100%;
  ${(props) =>
    Object.keys(props.themeCustom).length > 0 &&
    Object.prototype.hasOwnProperty.call(props.themeCustom, 'TabBarContainer') &&
    props.themeCustom.TabBarContainer};
`;
